import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {TranslateService} from '@ngx-translate/core';

import {CandidateClauseModel} from './candidate-clause.model';
import {ValidatorService} from '@core/validator/validator.service';
import {AlertService} from '@widgets/alert/alert.service';
import {CandidateClauseService} from '@core/ecv-http-services/services/candidate-clause.service';

@Component({
  selector: 'app-candidate-clause',
  templateUrl: './candidate-clause.component.html'
})
export class CandidateClauseComponent implements OnInit {

  candidateClauseForm: FormGroup;
  linkedinCandidateClauseForm: FormGroup;
  candidateClauseModel: CandidateClauseModel;
  linkedinCandidateClauseModel: CandidateClauseModel;

  constructor(private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private candidateClauseService: CandidateClauseService) {
    this.candidateClauseModel = new CandidateClauseModel();
    this.linkedinCandidateClauseModel = new CandidateClauseModel();
  }

  ngOnInit() {
    this.createForm();
  }

  sendClauseApprovalRequest(englishVersion: boolean) {
    this.validatorService.validate(this.candidateClauseForm);
    if (!this.validatorService.isValid(this.candidateClauseForm)) {
      this.showSendAlert(false);
      return;
    }

    this.candidateClauseModel.englishVersion = englishVersion;

    this.candidateClauseService.sendClauseApprovalRequest(this.candidateClauseModel).subscribe(
      response => {
        this.clearForm();
        this.createForm();
        this.showSendAlert(true);
      });
  }

  sendLinkedinClauseApprovalRequest(englishVersion: boolean) {
    this.validatorService.validate(this.linkedinCandidateClauseForm);
    if (!this.validatorService.isValid(this.linkedinCandidateClauseForm)) {
      this.showSendAlert(false);
      return;
    }

    this.linkedinCandidateClauseModel.type = 0;
    this.linkedinCandidateClauseModel.englishVersion = englishVersion;
    this.candidateClauseService.sendClauseApprovalRequest(this.linkedinCandidateClauseModel).subscribe(
      response => {
        this.clearForm();
        this.createForm();
        this.showSendAlert(true);
      });
  }

  private createForm(): void {
    this.candidateClauseForm = new FormGroup({
      'email': new FormControl('', [Validators.email, Validators.required])
    });
    this.linkedinCandidateClauseForm = new FormGroup({
      'email': new FormControl('', [Validators.email, Validators.required])
    });
  }

  private showSendAlert(valid: boolean) {
    if (valid) {
      this.translateService.get('ALERT.CANDIDATE_CLAUSE_SENT', {}).subscribe((res: string) => {
        this.alertService.success(res);
      });
    } else {
      this.translateService.get('ALERT.FIX_ERRORS', {}).subscribe((res: string) => {
        this.alertService.error(res);
      });
    }
  }

  private clearForm() {
    this.candidateClauseModel = new CandidateClauseModel();
    this.linkedinCandidateClauseModel = new CandidateClauseModel();
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/candidate-clause/candidate-clause.component.ts